import { default as default2 } from "./components/Viewer/Survey.vue.js";
import { default as default3 } from "./components/Viewer/SurveyViewer.vue.js";
import "vue";
/* empty css                                       */
import { default as default4 } from "./components/SurveyItemView/SurveyItemViewWrapper.vue.js";
import "lodash-es";
import "vuex";
import "./constants/SurveyItemType.js";
/* empty css                                     */
import "vuetify/components/VTextarea";
import "@products/base-portal-lib";
import "@products/base-portal-lib/composables";
import "vee-validate";
import "vuetify/components/VCard";
import "vuetify/components/VDialog";
import "vuetify/components/VDivider";
import "vuetify/components/VGrid";
/* empty css                                                      */
import "vuetify/components/VSwitch";
import "@products/base-portal-lib/plugins";
import "vue-dndrop/dist/vue-dndrop.esm";
import "vuetify/components/VIcon";
import "vuetify";
/* empty css                                          */
import "vuetify/components/VCheckbox";
import "vuetify/components/VChip";
import "vuetify/components/VDataTable";
import "vuetify/components/VTextField";
/* empty css                                            */
import "vuetify/components/VBtn";
import "vuetify/components/VList";
import "vuetify/components/VMenu";
/* empty css                                   */
import { default as default5 } from "./components/Editor/SurveyEditorWrapper.vue.js";
import "./assets/6024519d37aad045.png";
import "vuetify/components/VImg";
import "html2canvas";
import "@products/base-portal-lib/utils";
/* empty css                                   */
/* empty css                                 */
import { default as default6 } from "./components/Results/SurveyResults.vue.js";
import { default as default7 } from "./components/SurveyList/Surveys.vue.js";
import { default as default8 } from "./components/Audience/SurveyAudienceModule.vue.js";
import { getRoutes } from "./plugins/router.js";
import store from "./store/index.js";
import i18n from "./plugins/i18n.js";
import pageMaker from "./plugins/pageMaker.js";
import components from "./plugins/components.js";
const index = {
  install(app, options = {}) {
    app.use(store, "banza-survey");
    app.use(i18n, options);
    app.use(pageMaker);
    app.use(components);
  }
};
export {
  default2 as Survey,
  default8 as SurveyAudienceModule,
  default5 as SurveyEditorWrapper,
  default4 as SurveyItemViewWrapper,
  default6 as SurveyResults,
  default3 as SurveyViewer,
  default7 as Surveys,
  index as default,
  getRoutes
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgKiBmcm9tIFwiQC9jb21wb25lbnRzXCI7XG5cbmV4cG9ydCB7IGdldFJvdXRlcyB9IGZyb20gXCJAL3BsdWdpbnMvcm91dGVyXCI7XG5cbmltcG9ydCBzdG9yZSBmcm9tIFwiQC9zdG9yZVwiO1xuaW1wb3J0IGkxOG4gZnJvbSBcIkAvcGx1Z2lucy9pMThuXCI7XG5pbXBvcnQgcGFnZU1ha2VyIGZyb20gXCJAL3BsdWdpbnMvcGFnZU1ha2VyXCI7XG5pbXBvcnQgY29tcG9uZW50cyBmcm9tIFwiQC9wbHVnaW5zL2NvbXBvbmVudHNcIjtcblxuZXhwb3J0IGRlZmF1bHQge1xuXHRpbnN0YWxsKGFwcCwgb3B0aW9ucyA9IHt9KSB7XG5cdFx0YXBwLnVzZShzdG9yZSwgXCJiYW56YS1zdXJ2ZXlcIik7XG5cdFx0YXBwLnVzZShpMThuLCBvcHRpb25zKTtcblx0XHRhcHAudXNlKHBhZ2VNYWtlcik7XG5cdFx0YXBwLnVzZShjb21wb25lbnRzKTtcblx0fSxcbn07XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBU0EsTUFBZSxRQUFBO0FBQUEsRUFDZCxRQUFRLEtBQUssVUFBVSxJQUFJO0FBQzFCLFFBQUksSUFBSSxPQUFPLGNBQWM7QUFDN0IsUUFBSSxJQUFJLE1BQU0sT0FBTztBQUNyQixRQUFJLElBQUksU0FBUztBQUNqQixRQUFJLElBQUksVUFBVTtBQUFBLEVBQ2xCO0FBQ0Y7In0=
